import { Text } from '@cleartax/wg-library-typography';
import {
  THeader,
  THeaderCategory
} from '../../../../../../pages/services/[planSeoSlug]/api/types';
import { trackAction } from '../../../../../utils';

interface ICategoryDropDownContent {
  categoryList: THeader;
  categoryL2Setter?: (categoryList: THeader) => void;
  categroyL3Setter?: (categoryData: THeaderCategory) => void;
  level: 'L1' | 'L2';
}

export const CategoryDropDownContent: React.FC<ICategoryDropDownContent> = ({
  categoryList,
  categoryL2Setter,
  categroyL3Setter,
  level,
}) => {
  const borderClasses = 'border-b-sm border-dashed border-b-grey-300';

  const hoverHanlder = (
    category: THeaderCategory,
    levelSelected: 'L1' | 'L2'
  ) => {
    if (typeof categoryL2Setter === 'function')
      categoryL2Setter(category.subMenu);
    const categoryL3Category =
      levelSelected === 'L1' ? category.subMenu[0] : category;
    if (typeof categroyL3Setter === 'function')
      categroyL3Setter(categoryL3Category);
  };

  return (
    <>
      {categoryList.length
        ? categoryList.map((category, idx, categoryArr) => {
            return (
              <div key={category.categoryId} className="hover:bg-brand-200">
                <Text
                  onClick={() => {
                    trackAction('click', '', {
                      label: `top_nav_menu_item_${category.seoSlug}`,
                    });
                  }}
                  type="a"
                  href={`/services/${category.seoSlug}/c`}
                  mergeClasses="override"
                  onMouseOver={() => hoverHanlder(category, level)}
                  className={`text-brand-1000 mx-2 cursor-pointer flex justify-between items-center text-s-14 font-medium py-3 pl-6 ${
                    idx + 1 === categoryArr.length ? '' : borderClasses
                  }`}
                >
                  <Text textSize="sm" weight="medium">
                    {category.name}
                  </Text>
                  <div className="font-bold icon-right-arrow text-grey-800 mr-2 flex align-middle text-s-10" />
                </Text>
              </div>
            );
          })
        : null}
    </>
  );
};
